module.exports = __webpack_public_path__ + "static/img/four_04.cab9545.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/AtomicChain/assets/personalIntroduction/four_04.png
// module id = DhC7
// module chunks = 3